export const PAGE = "cleverstory.v2.widgets.page";
export const SLIDE = "cleverstory.v2.widgets.slide";
export const BASIC_TEXT = "cleverstory.v2.widgets.text.basic";
export const TEXT = "cleverstory.v2.widgets.text";
export const ANCHOR = "cleverstory.v2.widgets.anchor";
export const BUTTON = "cleverstory.v2.widgets.button";
export const PALETTE_COMPONENT = "cleverstory.v2.widgets.palette.component";

export const FORM = "cleverstory.v2.widgets.form";
export const FORM_STEP = "cleverstory.v2.widgets.form.step";
export const FORM_FIELD = "cleverstory.v2.widgets.form.input";
export const FORM_NUMBER = "cleverstory.v2.widgets.form.number";
export const FORM_TEXTAREA = "cleverstory.v2.widgets.form.textarea";
export const FORM_DROPDOWN_LIST = "cleverstory.v2.widgets.form.dropdown";
export const FORM_CHECK_LIST = "cleverstory.v2.widgets.form.checkbox";
export const FORM_CHECK_BOX = "cleverstory.v2.widgets.form.boolean";
export const FORM_SUBMIT = "cleverstory.v2.widgets.form.submit";

export const OTP_INPUT = "cleverstory.v2.widgets.otp.input";
export const OTP_FORM_SUBMIT = "cleverstory.v2.widgets.otp.submit";
export const OTP_RESEND = "cleverstory.v2.widgets.otp.resend";

export const EXTERNAL_FORM = "cleverstory.v2.widgets.form.external"

export const IFRAME = "cleverstory.v2.widgets.iframe";
export const HTML = "cleverstory.v2.widgets.html";

export const IMAGE = "cleverstory.v2.widgets.image";
export const VIDEO = "cleverstory.v2.widgets.video";

export const SHAPE = "cleverstory.v2.widgets.shape";
export const LINE = "cleverstory.v2.widgets.line";

export const CONTENT = "cleverstory.v2.widgets.content";
export const CONTENT_FILTER = "cleverstory.v2.widgets.content.filter";
export const CONTENT_SEARCH = "cleverstory.v2.widgets.content.filter.search";
export const CONTENT_FILTER_CONTAINER = "cleverstory.v2.widgets.content.filter.container";
export const CONTENT_LOADING = "cleverstory.v2.widgets.content.loading";
export const CONTENT_EMPTY_MESSAGE = "cleverstory.v2.widgets.content.empty";
export const CONTENT_PAGINATION_BUTTON = "cleverstory.v2.widgets.content.pagination.button";
export const CONTENT_CARD = "cleverstory.v2.widgets.content.card";
export const CONTENT_CARD_TEMPLATE = "cleverstory.v2.widgets.content.card.template";

export const ASSET = "cleverstory.v2.widgets.asset";

export const LIVE_ELEMENT = "cleverstory.v2.widgets.liveElement"
export const LIVE_ELEMENT_CONTAINER = "cleverstory.v2.widgets.liveElement.container";

export const RECTANGLE = "cleverstory.v2.widgets.rectangle";
export const SECTION = "cleverstory.v2.widgets.section";
export const SECTION_COLUMN = "cleverstory.v2.widgets.section.column";

export const MENU = "cleverstory.v2.widgets.menu";
export const MENU_CONTAINER = "cleverstory.v2.widgets.menu.container";
export const MENU_DRAGGABLE_CONTAINER = "cleverstory.v2.widgets.menu.draggable.container";

export const GROUP = "cleverstory.v2.widgets.group";
export const MODAL = "cleverstory.v2.widgets.modal";

export const HOTSPOT = "cleverstory.v2.widgets.hotspot";
export const POPUP = "cleverstory.v2.widgets.popup";

export const CAROUSEL = 'cleverstory.v2.widgets.carousel';
export const CAROUSEL_CARD = 'cleverstory.v2.widgets.carousel.card';

export const SEEK = 'cleverstory.v2.widgets.seek';